import type { Components, Theme } from "@mui/material/styles";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    variant: "contained",
    fullWidth: true,
    size: "medium",
    disableElevation: true,
  },

  styleOverrides: {
    root: () => ({
      textTransform: "none",
      borderRadius: "0.75rem",
      fontSize: "0.95rem",
      fontWeight: 700,
      padding: "14px 16px",
      transition: "all 0.2s ease",
      boxShadow: "0 10px 20px rgba(27,36,70,0.25)",

      "&:active": {
        transform: "scale(0.98)",
        boxShadow: "0 2px 4px rgba(27,36,70,0.25)",
      },
    }),

    sizeSmall: {
      padding: "6px 16px",
      fontSize: "0.8125rem",
      minHeight: 34,
    },

    contained: ({ theme }) => ({
      color: theme.palette.primary.contrastText,
      boxShadow: "0 10px 20px rgba(27,36,70,0.25)",

      "&:hover": {
        boxShadow: "0 2px 4px rgba(27,36,70,0.35)",
      },
    }),
    
    containedPrimary: ({ theme }) => ({
      backgroundColor: theme.palette.primary.main,

      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    }),

    containedSecondary: ({ theme }) => ({
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,

      "&:hover": {
        backgroundColor: theme.palette.secondary.dark,
      },
    }),

    outlined: () => ({
      borderWidth: "2px",
      boxShadow: "none",

      "&:hover": {
        borderWidth: "2px",
        boxShadow: "0 1px 2px rgba(27,36,70,0.15)",
      },
    }),

    outlinedPrimary: ({ theme }) => ({
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,

      "&:hover": {
        backgroundColor: theme.palette.primary.main + "10",
      },
    }),

    outlinedSecondary: ({ theme }) => ({
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,

      "&:hover": {
        backgroundColor: theme.palette.secondary.main + "15",
      },
    }),

    text: () => ({
      padding: "8px 10px",
      boxShadow: "none",
    }),

    textPrimary: ({ theme }) => ({
      color: theme.palette.primary.main,

      "&:hover": {
        backgroundColor: theme.palette.primary.main + "10",
      },
    }),

    textSecondary: ({ theme }) => ({
      color: theme.palette.secondary.main,

      "&:hover": {
        backgroundColor: theme.palette.secondary.main + "10",
      },
    }),
  },
};
